var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreedots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.78516C18 10.8897 17.1046 11.7852 16 11.7852C14.8954 11.7852 14 10.8897 14 9.78516C14 8.68059 14.8954 7.78516 16 7.78516C17.1046 7.78516 18 8.68059 18 9.78516ZM18 16C18 17.1046 17.1046 18 16 18C14.8954 18 14 17.1046 14 16C14.0001 14.8955 14.8955 14 16 14C17.1045 14 17.9999 14.8955 18 16ZM18 22.2148C18 23.3194 17.1046 24.2148 16 24.2148C14.8954 24.2148 14 23.3194 14 22.2148C14.0002 21.1104 14.8955 20.2148 16 20.2148C17.1045 20.2148 17.9998 21.1104 18 22.2148Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedots);
export default __webpack_public_path__ + "static/media/threedots.d5a40e15d758867f119dc981d75f53dd.svg";
export { ForwardRef as ReactComponent };